import React, { useState } from 'react';
import styles from './CommonMultiselect.module.css';
import { Option } from '../../../models/component-models/ComponentModels';

interface MultiSelectProps {
  options: Option[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  placeholder?: string;
  error?: string;
}

export const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  value,
  onChange,
  label,
  placeholder,
  error,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (optionValue: string) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.selectContainer}>
        <div
          className={`${styles.select} ${error ? styles.error : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {value.length > 0
            ? options
                .filter(opt => value.includes(opt.value))
                .map(opt => opt.label)
                .join(', ')
            : placeholder}
        </div>
        {isOpen && (
          <div className={styles.dropdown}>
            {options.map(option => (
              <div
                key={option.value}
                className={styles.option}
                onClick={() => handleSelect(option.value)}
              >
                <input type="checkbox" checked={value.includes(option.value)} readOnly />
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};
